<div
  *ngIf="context === 'accession'"
  class="flex flex-col gap-2">
  <span class="text-[18px] font-bold">Esta adhesion necesita la aprobación de los siguientes roles:</span>
  <span
    *ngIf="dpd"
    class="text-[16px] text-neutral-dark">
    El jefe/a de servicio supervisor y la persona delegada de protección de datos tienen que aprobar la solicitud
  </span>
  <span
    *ngIf="!dpd"
    class="text-[16px] text-neutral-dark">
    El jefe/a de servicio supervisor tiene que aprobar la solicitud
  </span>
</div>
<span
  *ngIf="context !== 'accession'"
  class="text-[18px] font-bold">
  Proceso de tramitación
</span>

<div class="flex flex-col mt-4 border-t border-neutral-base">
  <div
    *ngFor="let stage of stateGroupNormalized"
    class="flex items-center justify-between py-4 border-b border-neutral-base">
    <span class="text-neutral-dark">{{ stage.group }}</span>
    <div class="flex items-center gap-6">
      <button
        *ngIf="shouldShowStageReviewButton(stage.groupKey)"
        type="button"
        class="text-[14px] text-primary-base underline bg-transparent border-none p-0 font-semibold cursor-pointer"
        (click)="onReview?.()">
        {{ reviewButtonLabel }}
      </button>

      <div class="flex items-centergap-3">
        <span class="text-md font-bold">{{ stage.state }}</span>
      </div>
    </div>
  </div>
</div>
